import { authStorage } from "../../api/authStorage";
import { PERMISSIONS } from "../../config/permissions";
import { LOAD_PERMISSIONS, RESET_TOKEN, TOKENS_UPDATE, USER_DETAILS, USER_LOGOUT, USER_PERMISSIONS, USER_UPDATE } from "./authTypes";


const initialState = {
  // user: JSON.parse(localStorage.getItem('auth')) || null,
  // accessToken: localStorage.getItem("auth_access_token") || null,
  // refreshtoken: localStorage.getItem("refreshtoken") || null,
  user: authStorage.getAuth() || null,
  accessToken: authStorage.getAccessToken() || null,
  refreshtoken: authStorage.getRefreshToken() || null,
  resetToken: false,
  userDetails: null,
  permissionsLoad: false,
  userPermissions: PERMISSIONS
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_UPDATE:
      return {
        ...state,
        user: action.payload,
      };
    case TOKENS_UPDATE:
      return {
        ...state,
        accessToken: action.payload.token,
        refreshtoken: action.payload.refreshToken,
      };
    case RESET_TOKEN:
      return {
        ...state,
        resetToken: action.payload,
      };
    case USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
        user: action.payload,
      };
    case USER_LOGOUT:
      return {
        ...state,
        user: null,
        accessToken: null,
        refreshtoken: null,
        resetToken: false,
        userDetails: null
      };
    case LOAD_PERMISSIONS:
      return {
        ...state,
        permissionsLoad: true,
      };
    case USER_PERMISSIONS:
      return {
        ...state,
        userPermissions: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
